import { useRouter } from "next/router";
import {
  Action,
  Container,
  Icon,
  PageLink,
  Paragraph,
} from "shared/components";

import styles from "./Content013.module.scss";

export const Content013 = ({ payload }) => {
  const title = payload?.title ?? "";
  const pageLink = payload?.pageLink ?? "";

  const router = useRouter();

  return (
    <div className={styles.wrapper}>
      <Container className={styles.inner}>
        {pageLink ? (
          <PageLink link={pageLink} className={styles.link}>
            <span className={styles.arrow}>
              <Icon className={styles.icon} name="arrow_slider_prev" />
            </span>
            <Paragraph className={styles.title} color="dark" uppercase>
              {title}
            </Paragraph>
          </PageLink>
        ) : (
          <Action onClick={() => router.back()} className={styles.link}>
            <span className={styles.arrow}>
              <Icon className={styles.icon} name="arrow_slider_prev" />
            </span>
            <Paragraph className={styles.title} color="dark" uppercase>
              {title}
            </Paragraph>
          </Action>
        )}
      </Container>
    </div>
  );
};

export default Content013;
